// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullAnalysisFolderSettings_head{
    display: flex;
    justify-content: space-between;
}

.FullAnalysisFolderSettings_title{

}

.FullAnalysisFolderSettings_form{
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
}

.FullAnalysisFolderSettings_buttons{
    display: flex;
    justify-content: flex-end;
}

.FullAnalysisFolderSettings_iconsSection{

}

.FullAnalysisFolderSettings_iconsSection_title{

}

.FullAnalysisFolderSettings_nameSection{

}

.FullAnalysisFolderSettings_nameSection_title{

}

.FullAnalysisFolderSettings_name{

}

.FullAnalysisFolderSettings_icons{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.FullAnalysisFolderSettings_icon{
    width: 32px;
    height: 32px;
    /*border-radius: 100%;*/
    flex-shrink: 0;
    /*background-color: #ccc;*/

    background-position: center;
    background-repeat: no-repeat;
    background-size: contain; 
    border: 1px solid #ccc0;
}

.FullAnalysisFolderSettings_icon--active{
   border-radius: 3px;
   border: 1px solid #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/fullAnalysis/FullAnalysisFolderSettings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,0BAA0B;;IAE1B,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;GACG,kBAAkB;GAClB,sBAAsB;AACzB","sourcesContent":[".FullAnalysisFolderSettings_head{\n    display: flex;\n    justify-content: space-between;\n}\n\n.FullAnalysisFolderSettings_title{\n\n}\n\n.FullAnalysisFolderSettings_form{\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    height: 100%;\n}\n\n.FullAnalysisFolderSettings_buttons{\n    display: flex;\n    justify-content: flex-end;\n}\n\n.FullAnalysisFolderSettings_iconsSection{\n\n}\n\n.FullAnalysisFolderSettings_iconsSection_title{\n\n}\n\n.FullAnalysisFolderSettings_nameSection{\n\n}\n\n.FullAnalysisFolderSettings_nameSection_title{\n\n}\n\n.FullAnalysisFolderSettings_name{\n\n}\n\n.FullAnalysisFolderSettings_icons{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.FullAnalysisFolderSettings_icon{\n    width: 32px;\n    height: 32px;\n    /*border-radius: 100%;*/\n    flex-shrink: 0;\n    /*background-color: #ccc;*/\n\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain; \n    border: 1px solid #ccc0;\n}\n\n.FullAnalysisFolderSettings_icon--active{\n   border-radius: 3px;\n   border: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
